import mapStyles from './mapStyles';

/** @param {FF.Location} location */
export const getGoogleMapsLink = location =>
  `https://www.google.com/maps/dir/?api=1&destination=${location.locationConfigs.coordinates.latitude},${location.locationConfigs.coordinates.longitude}`;

/**
 * @param {FF.Location} location
 * @param {string} googleMapsApiKey
 * */
export const getStaticGoogleMapUrl = (location, googleMapsApiKey) => {
  const queryParams = [];
  const latLngString = `${location.locationConfigs.coordinates.latitude},${location.locationConfigs.coordinates.longitude}`;
  queryParams.push(['center', latLngString]);
  queryParams.push(['size', '640x428']);
  if (typeof window === 'object') {
    queryParams.push([
      'scale',
      window.devicePixelRatio ? Math.max(window.devicePixelRatio, 2) : 1,
    ]);
  }
  queryParams.push(['key', googleMapsApiKey]);

  const markerIconURL =
    location.type === 'WHOLESALE'
      ? 'https://res.cloudinary.com/fftech/image/upload/w_64,h_64,q_100/v1692295802/Website%20Assets/RetailMapPin.png'
      : 'https://res.cloudinary.com/fftech/image/upload/w_64,h_64,q_100/v1692295802/Website%20Assets/FridgeMapPin.png';
  queryParams.push([
    'markers',
    `anchor:bottom%7Cicon:${markerIconURL}%7C${latLngString}`,
  ]);
  mapStyles.forEach(({ featureType, elementType, stylers }) => {
    queryParams.push([
      'style',
      `feature:${featureType}${
        elementType ? `%7Celement:${elementType}` : ''
      }%7C${stylers
        .map(obj =>
          Object.keys(obj)
            // @ts-ignore
            .map(key => `${key}:${encodeURIComponent(obj[key])}`)
            .join('%7C'),
        )
        .join('%7C')}`,
    ]);
  });

  return `https://maps.googleapis.com/maps/api/staticmap?${Array.from(
    queryParams,
  )
    .map(obj => `${obj[0]}=${obj[1]}`)
    .join('&')}`;
};
